module.exports = __webpack_public_path__ + "static/d-palmer.96441d29.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/d-palmer.png
// module id = 493
// module chunks = 256317873200919